<template>
  <div class="warn-release">
    <Card>
      <Card :dis-hover="true" :bordered="false" :padding="0" style="margin-bottom: 16px">
        <Row type="flex" justify="start">
          <Col v-if="curRole === '市中心管理人员'" :span="4">
            <span>发布中心：</span>
            <Select transfer v-model="createUser" clearable style="width:200px">
              <Option v-for="(item) in centerList" :key="item.id" :value="item.userId">{{ item.name }}</Option>
            </Select>
          </Col>
          <Col :span="4">
            <span>预警类型：</span>
            <Select transfer v-model="warnType" clearable style="width:200px">
              <Option v-for="(item) in warnTypeList" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </Col>
          <Col :span="8">
            <span>发布时间：</span>
            <DatePicker transfer type="datetime" placeholder="请选择起始时间" v-model="startTime"></DatePicker>
            <span> — </span>
            <DatePicker transfer type="datetime" placeholder="请选择结束时间" v-model="endTime"></DatePicker>
          </Col>
          <Col :span="2">
            <Button type="primary" @click="getEmergencyWarnings" style="margin-left: 8px">查询</Button>
          </Col>
          <Col :span="4">
            <Button code="emergency.warning.release" type="primary" @click="gotoRelease">预警发布</Button>
          </Col>
        </Row>
      </Card>
      <Table
        :loading="dataLoading"
        :columns="columns"
        :data="data"
        :border="false"
        :stripe="false"
        :highlight-current-row="true"
      >
        <template #action="{ row, index }">
          <el-button :disabled="row.status === '1'" size="small" type="text" @click="editWarnInfo(row)">编辑</el-button>
          <el-button :disabled="row.status === '1'" size="small" type="text" @click="releaseWarnInfo(row, 1)">发布
          </el-button>
          <el-button :disabled="row.createUser !== curUser" size="small" type="text" @click="deleteWarnInfo(row)">删除
          </el-button>
          <!--        <el-button v-if="row.status === '1'" size="small" type="text" @click="">关闭（发布）</el-button>-->
        </template>
      </Table>
      <Page style="text-align: right;margin-top: 10px"
            show-sizer
            show-total
            transfer
            :total="dataTotal"
            :page-size="pageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="currentPage"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
  </div>
</template>

<script>
export default {
  name: "warningRelease",
  data() {
    return {
      countryList: [],
      centerList: [],
      warnTypeList: [],
      warnType: null,
      createUser: null,
      startTime: null,
      endTime: null,
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '预警标题',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.title)
          }
        },
        {
          title: '预警类型',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.typeName)
          }
        },
        {
          title: '预警描述',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.description)
          }
        },
        {
          title: '预警区县',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.countysname)
          }
        },
        {
          title: '发布中心',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.createUserName)
          }
        },
        {
          title: '状态',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.status === '0' ? '草稿' : '已发布')
          }
        },
        {
          width: '150',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1,
      curRole: '',
      curUser: ''
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          console.log(newVal)
          this.curRole = newVal.roleNames
          this.curUser = newVal.userId
        }
      }
    }
  },
  computed: {
    userInfo: {
      get: function () {
        return this.$store.state.user.userInfo
      },
      set: function () {
      }
    }
  },
  mounted() {
    // this.getCountry()
    this.getCenterList()
    this.getWarningType()
    this.getEmergencyWarnings()
  },
  methods: {
    //区县
    getCountry() {
      this.$http.get('/api/getLowerLevelDepts?flag=3').then(res => {
        // console.log(res)
        this.countryList = res.data.data
      })
    },
    //预警类型
    getWarningType() {
      this.$http.get('/api/earlyWarningTypes').then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.warnTypeList = res.data.data
        }
      })
    },
    //发布中心
    getCenterList() {
      this.$http.get('/api/getCenterList').then(res => {
        console.log(res)
        this.centerList = res.data
      })
    },
    gotoRelease() {
      this.$router.push({name: 'warnInfo'})
    },
    editWarnInfo(row) {
      this.$router.push({
        name: 'warnInfo',
        params: {
          row: row
        }
      })
    },
    deleteWarnInfo(row) {
      this.$http.delete(`/api/emergencyWarnings/${row.id}`).then(res => {
        // console.log(res)
        this.getEmergencyWarnings()
      })
    },
    releaseWarnInfo(row, status) {
      let params = {...row}
      params.status = status
      this.$http.put('/api/emergencyWarnings', params).then(res => {
        if (res.status === 200 || res.status === 201) {
          this.$Message.success('发布完成！')
          this.getEmergencyWarnings()
        } else {
          this.$Message.error(res.data.message)
        }
      })
    },
    getEmergencyWarnings() {
      this.dataLoading = true
      let params = {
        type: this.warnType,
        createUser: this.createUser,
        startTime: this.startTime,
        endTime: this.endTime,
        page: this.currentPage,
        size: this.pageSize
      }
      this.$http.post('/api/getEmergencyWarningsList', params).then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.data = res.data.data
          this.dataTotal = res.data.recordsTotal
          this.dataLoading = false
        }
      })
    },
    pageChange(page) {
      this.currentPage = page
      this.getEmergencyWarnings()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getEmergencyWarnings()
    },
  }
}
</script>

<style scoped lang="less">
.warn-release {
}
</style>
